<template>
  <div class="modal">
    <div class="modal-bg" @click="$emit('close')"></div>
    <div class="modal-block">
      <div class="modal-header">
        <h3>
          Charge Account
        </h3>
      </div>
      <div class="modal-body">
        <div class="text-center mt-5" v-if="ui.loading === true">
          <div class="spinner-border mt-5" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
        <div v-else>
          <div class="modal-body-container">
            <div class="row">
              <div class="col-1">
                <v-avatar username="John Smith" :size="56" rounded />
              </div>
              <div class="col-11 ps-4 my-auto">
              <span>
                John Smith
              </span>
              </div>
            </div>
          </div>
          <div class="modal-body-container">
            <div class="form-group full-width">
              <label for="fieldTotalPrice">
                Total Price
              </label>
              <input type="text" class="form-control disabled"
                     id="fieldTotalPrice" v-model="totalPrice" disabled>
            </div>
            <div class="form-group full-width mt-3">
              <label for="fieldMargin">
                Margin ($ per lead)
              </label>
              <input type="number" class="form-control" step=".1" id="fieldMargin" v-model="margin" @change="calcTotalPrice">
            </div>
          </div>
          <div class="modal-body-container">
            <div class="table">
              <table class="table">
                <thead>
                <tr>
                  <th>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" v-model="checkAll" @click="toggleCheckAll">
                    </div>
                  </th>
                  <th>Id</th>
                  <th>Campaign</th>
                  <th>Date</th>
                  <th>Amount</th>
                  <th>Price</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(el, index) in formData" :key="index">
                  <td>
                    <div class="form-check">
                      <input type="checkbox" class="form-check-input" v-model="el.isChecked" @click="el.isChecked = !el.isChecked; calcTotalPrice()">
                    </div>
                  </td>
                  <td>{{ el.id }}</td>
                  <td>{{ el.campaign }}</td>
                  <td>{{ el.date }}</td>
                  <td>${{ el.amount }}</td>
                  <td>${{ el.price }}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer d-flex justify-content-start" v-if="ui.loading === false">
        <button class="btn bg-green" @click="charge">
           <span v-if="ui.saving === true"
                 class="spinner-border spinner-border-sm text-light"
                 role="status" aria-hidden="true">
          </span>
          <span class="text-end" v-else>
            Charge
          </span>
        </button>
        <button class="btn btn-cancel" @click="$emit('close')">
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChargeModal",
  data() {
    return {
      margin: 0,
      formData: [],
      totalPrice: '',
      checkAll: true,
      ui: {
        loading: false,
        saving: false
      }
    }
  },
  methods: {
    getData() {
      this.ui.loading = true;
      setTimeout(() => {
        this.ui.loading = false;
        this.formData = [
          {id: 1, campaign: 'Ryan_Parto', date: 'Nov, 08 2020', amount: '450,000.00', price: 20.00},
          {id: 2, campaign: 'Ryan_Parto', date: 'Nov, 08 2020', amount: '450,000.00', price: 20.00}
          ];
        this.formData.map((el) => {
          el.isChecked = true;
        });
        this.calcTotalPrice();
      }, 1000)
    },
    calcTotalPrice() {
      let margin = this.margin;
      let totalPrice = .0;

      if (!margin) { margin = 0; }

      this.formData.map((el) => {
        if (el.isChecked === true) {
          totalPrice += Number.parseFloat(el.price) + Number(margin);
        }
      });

      this.totalPrice = totalPrice;
    },
    toggleCheckAll() {
      this.checkAll = !this.checkAll;

      this.formData.map((el) => {
        if (this.checkAll === false) {
          el.isChecked = false;
        } else {
          el.isChecked = true;
        }
      });

      this.calcTotalPrice();
    },
    charge() {
      this.ui.saving = true;

      setTimeout(() => {
        this.ui.saving = false;
        this.$emit('close');
      }, 1000)
    }
  },
  created() {
    this.getData();
  }
}
</script>

<style lang="scss" scoped>
.form-check {
  padding: 0;
  margin: 0;
  input {
    width: 18px!important;
    height: 18px;
    padding: 0;
    margin: 0;
  }
}
div.table {
  table {
    thead {
      tr {
        th {
          &:first-child {
            padding-left: 15px;
          }
        }
      }
    }
  }
}
</style>
